module.exports = __webpack_public_path__ + "img/home_ic3.e89fbd6c.jpg";